import type { RawWPRestBrand } from "../../../../../types";
import type { TransformedWPBrand } from "../../types/productTaxonomyApiTypes";

/**
 * Transforms a raw WP REST API brand object into the application's TransformedWPBrand structure.
 * Note: Brands are not translated in this implementation.
 * @param brand - The raw brand data from the WP REST API.
 * @returns The transformed brand data.
 */
export const transformBrand = (brand: RawWPRestBrand): TransformedWPBrand => {
  return {
    id: brand.id,
    name: brand.name,
    slug: brand.slug,
    parent: brand.parent,
    description: brand.description,
    count: brand.count,
    taxonomy: brand.taxonomy,
  };
};
